module.exports = __webpack_public_path__ + "img/icon-help.83239118.svg";